import React from 'react';
import CustomTooltip from 'views/pages/manage/common/customTooltip/CustomTooltip';
import { jodoColumn } from '../constant';
import styles from "./style.module.scss";
const TableHeader=()=>{
    return(<div className={`${styles["table-header"]} text-bold label-color pb-2 ml-3`}>
       {jodoColumn?.map((item)=>(
        <CustomTooltip key ={item.label} title={item.hoverDescription}>
                <div className='ml-0' key={item.label}>{item.label}</div>
        </CustomTooltip>
       ))}
            
    </div>
    )
}
export default TableHeader